module.exports = __webpack_public_path__ + "static/media/Marill_gaussian2.432dd509.png";